// stringtable.ts ↔ game/stringtable.cpp — the shipped string table (strings.bin
// out of the pack, ids = game/wistrings.h): a big-endian word offset per id, a
// byte-counted string at the offset. The C++ reads through gpakr per call; the
// file is ~1KB so this reader holds the mapped bytes.

import type { PackFileReader } from './packfile.ts';

export class StringTable {
  private bytes: Uint8Array | null = null;

  // StringTable::Init (stringtable.cpp:19-23)
  Init(pakr: PackFileReader, szFilename = 'strings.bin'): boolean {
    this.bytes = pakr.MapFile(szFilename);
    return this.bytes !== null;
  }

  // StringTable::GetString (stringtable.cpp:25-56) — BigWord offset, byte length
  GetString(ids: number): string | null {
    const b = this.bytes;
    if (b === null || 2 * ids + 1 >= b.length) return null;
    const off = (b[2 * ids] << 8) | b[2 * ids + 1];
    if (off >= b.length) return null;
    const cb = b[off];
    if (off + 1 + cb > b.length) return null;
    let sz = '';
    for (let i = 0; i < cb; i++) sz += String.fromCharCode(b[off + 1 + i]);
    return sz;
  }
}

// game/wistrings.h — the alert ids the live session raises
export const kidsMinerUnderAttack = 0;
export const kidsLowPower = 2;
export const kidsWarehouseTooFull = 3;
export const kidsBaseUnderAttack = 4;
// game/wistrings.h — the rank-title block ($ranktitle expansion)
export const kidsRankChallenger = 10;
export const kidsRank0 = 11;
// game/wistrings.h — the MP exit-confirm strings (Game::AskResignGame). These were off by one
// (37/38); strings.bin holds ids 0-37, so kidsExitClient=38 ran off the end → GetString null → the
// AskResignGame WARNING box rendered with a BLANK body (the title + Yes/No still showed). The C++
// enum order (kidsExitHost then kidsExitClient) and the shipped strings.bin both put these at 36/37.
export const kidsExitHost = 36;
export const kidsExitClient = 37;

// game/misc.cpp:1768-1779 — GetRankTitle. getVar = the pvars 'rank' lookup
// (rank "Challenger" is hardcoded in the level files as -1).
export function GetRankTitle(strtbl: StringTable, getVar: (name: string) => string | null): string {
  let nRank = 0;
  const szT = getVar('rank');
  if (szT !== null) nRank = parseInt(szT, 10) || 0; // atoi
  return strtbl.GetString(kidsRank0 + nRank) ?? '';
}
